(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('yg-buy-now-button')) {
    class YGBuyNowButton extends HTMLElement {
      connectedCallback() {
        if (this._initialized) {
          this._syncButtonState();
          return;
        }

        this._initialized = true;
        this._button = this.querySelector('button');
        if (this._button && !this._button.dataset.defaultLabel) {
          this._button.dataset.defaultLabel = this._button.textContent.trim();
        }
        this._productForm = document.forms[this.dataset.formId];
        this._productInfo = this.closest('.product-info') || document;
        this._onClick = this._onClick.bind(this);
        this._onVariantChange = this._onVariantChange.bind(this);
        this._onPartsChange = this._onPartsChange.bind(this);
        this._button?.addEventListener('click', this._onClick);
        this._productForm?.addEventListener('variant:change', this._onVariantChange);
        this._productInfo?.addEventListener('yg:product-parts:change', this._onPartsChange);
        this._syncButtonState();
      }

      disconnectedCallback() {
        this._button?.removeEventListener('click', this._onClick);
        this._productForm?.removeEventListener('variant:change', this._onVariantChange);
        this._productInfo?.removeEventListener('yg:product-parts:change', this._onPartsChange);
        this._initialized = false;
      }

      get graphqlUrl() {
        return `https://${Shopify.shop}/api/${this.dataset.apiVersion || '2026-01'}/graphql.json`;
      }

      async _onClick() {
        if (!this._button || this._button.disabled || !this._productForm) {
          return;
        }

        if (!this._productForm.checkValidity()) {
          this._productForm.reportValidity();
          return;
        }

        const lines = this._buildCheckoutLines();

        if (!lines.length) {
          return;
        }

        this._setBusy(true);

        try {
          const response = await fetch(this.graphqlUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': this.dataset.storefrontApiKey,
            },
            body: JSON.stringify({
              query: `mutation YGBuyNowCreateCart($input: CartInput!) { cartCreate(input: $input) { cart { checkoutUrl } userErrors { field message } } }`,
              variables: {
                input: {
                  lines,
                },
              },
            }),
          });
          const json = await response.json();
          const topLevelErrors = Array.isArray(json.errors) ? json.errors.map((error) => error.message).filter(Boolean) : [];
          const userErrors = json.data?.cartCreate?.userErrors || [];
          const errorMessages = topLevelErrors.concat(userErrors.map((error) => error.message).filter(Boolean));

          if (!response.ok || errorMessages.length) {
            throw new Error(errorMessages.join(', ') || this.dataset.errorLabel || 'Unable to start checkout.');
          }

          const checkoutUrl = json.data?.cartCreate?.cart?.checkoutUrl;

          if (!checkoutUrl) {
            throw new Error(this.dataset.errorLabel || 'Unable to start checkout.');
          }

          window.location.href = checkoutUrl;
        } catch (error) {
          this._productForm.dispatchEvent(new CustomEvent('cart:error', {
            bubbles: true,
            detail: {
              error: error instanceof Error ? error.message : this.dataset.errorLabel || 'Unable to start checkout.',
            },
          }));
        } finally {
          this._setBusy(false);
        }
      }

      _onVariantChange(event) {
        this._currentVariant = event.detail?.variant || null;
        this._syncButtonState();
      }

      _onPartsChange() {
        this._syncButtonState();
      }

      _setBusy(isBusy) {
        if (!this._button) {
          return;
        }

        this._button.disabled = isBusy || !this._isVariantAvailable();
        this._button.toggleAttribute('aria-busy', isBusy);
        this._button.textContent = isBusy ? (this.dataset.loadingLabel || 'Redirecting...') : this._getDefaultLabel();
      }

      _syncButtonState() {
        if (!this._button) {
          return;
        }

        this._button.disabled = !this._isVariantAvailable();
        this._button.textContent = this._getDefaultLabel();
      }

      _getDefaultLabel() {
        return this._button?.dataset.defaultLabel || this._button?.textContent?.trim() || 'Buy now';
      }

      _isVariantAvailable() {
        if (this._currentVariant && this._currentVariant.id) {
          return this._currentVariant.available !== false;
        }

        return this.dataset.variantAvailable === 'true' && !!this._getSelectedVariantId();
      }

      _buildCheckoutLines() {
        const formData = this._productForm ? new FormData(this._productForm) : null;
        const quantity = this._getQuantity(formData);
        const items = [{
          variantId: this._getSelectedVariantId(),
          quantity,
          attributes: this._getLineItemAttributes(formData),
          sellingPlanId: this._getSellingPlanId(formData),
        }];
        const selectedParts = this._getSelectedParts();

        selectedParts.forEach((item) => {
          if (!item.available || !item.variantId) {
            return;
          }

          items.push({
            variantId: item.variantId,
            quantity: Number.parseInt(item.quantity || '1', 10) || 1,
          });
        });

        return Object.values(items.reduce((accumulator, item) => {
          if (!item.variantId || item.quantity <= 0) {
            return accumulator;
          }

          const key = JSON.stringify([
            String(item.variantId),
            item.sellingPlanId || '',
            item.attributes || [],
          ]);

          if (!accumulator[key]) {
            accumulator[key] = {
              merchandiseId: this._toGid(item.variantId),
              quantity: item.quantity,
            };

            if (item.attributes?.length) {
              accumulator[key].attributes = item.attributes;
            }

            if (item.sellingPlanId) {
              accumulator[key].sellingPlanId = item.sellingPlanId;
            }
          } else {
            accumulator[key].quantity += item.quantity;
          }

          return accumulator;
        }, {}));
      }

      _getSelectedParts() {
        const partsRoot = this.closest('.product-info')?.querySelector('yg-product-parts');

        if (partsRoot?.getSelectedItems) {
          return partsRoot.getSelectedItems();
        }

        return Array.from(partsRoot?.querySelectorAll('.yg-parts-item.is-selected') || [])
          .filter((item) => item.dataset.available !== 'false')
          .map((item) => ({
            variantId: item.dataset.variantId || '',
            available: item.dataset.available !== 'false',
            quantity: 1,
          }));
      }

      _getSelectedVariantId() {
        if (this._currentVariant?.id) {
          return String(this._currentVariant.id);
        }

        const variantInput = this._productForm?.querySelector('[name="id"]');
        return variantInput?.value ? String(variantInput.value) : '';
      }

      _getQuantity(formData) {
        const rawQuantity = formData?.get('quantity');
        const quantity = Number.parseInt(rawQuantity || '1', 10) || 1;
        return quantity > 0 ? quantity : 1;
      }

      _getLineItemAttributes(formData) {
        if (!formData) {
          return [];
        }

        const attributes = [];

        formData.forEach((value, key) => {
          if (!key.startsWith('properties[') || value === '' || value === null) {
            return;
          }

          const match = key.match(/^properties\[(.*)\]$/);

          if (!match || !match[1]) {
            return;
          }

          attributes.push({
            key: match[1],
            value: String(value),
          });
        });

        return attributes;
      }

      _getSellingPlanId(formData) {
        const value = formData?.get('selling_plan');
        return value ? String(value) : '';
      }

      _toGid(variantId) {
        const value = String(variantId || '');
        return value.indexOf('gid://') === 0 ? value : `gid://shopify/ProductVariant/${value}`;
      }
    }

    window.customElements.define('yg-buy-now-button', YGBuyNowButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-anchor-item"] && !Shopify.designMode) return;
  try {
    class YGAnchorItem extends HTMLElement {
      #observedSection = null;
      static observer = null;
      static sectionToItem = new Map();
      static isScroll = false;

      constructor() {
        super();
        this.itemClick = this.itemClick.bind(this);
        this.sections = null;
      }

      connectedCallback() {
        this.sections = document.querySelectorAll('#main .shopify-section');
        this.addEventListener('click', this.itemClick);

        const sectionNumber = Number(this.getAttribute('data-section-number') || 0);
        if (!this.sections?.length || !Number.isFinite(sectionNumber) || sectionNumber <= 0) return;

        const section = this.sections[sectionNumber - 1];
        if (!section) return;

        this.#observedSection = section;
        YGAnchorItem.#ensureObserver();
        YGAnchorItem.sectionToItem.set(section, this);
        YGAnchorItem.observer.observe(section);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);

        if (this.#observedSection && YGAnchorItem.observer) {
          YGAnchorItem.sectionToItem.delete(this.#observedSection);
          YGAnchorItem.observer.unobserve(this.#observedSection);
        }
      }

      static #ensureObserver() {
        if (YGAnchorItem.observer) return;

        YGAnchorItem.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const item = YGAnchorItem.sectionToItem.get(entry.target);
              if (!YGAnchorItem.isScroll) {
                item && item.setActiveFromObserver();
              }
            });
          },
          {
            root: null,
            threshold: 0.01,
            rootMargin: '-20% 0px -70% 0px',
          }
        );
      }

      setActiveFromObserver() {
        let id = this.getAttribute('data-id');
        let $anchorList;
        if (id) {
          $anchorList = this.parentElement
            ? Array.from(document.querySelectorAll(`yg-anchor-item[data-id="${id}"]`))
            : [];
        } else {
          $anchorList = this.parentElement
            ? Array.from(this.parentElement.querySelectorAll('yg-anchor-item'))
            : [];
        }

        $anchorList.forEach((el, index) => {
          el.classList.toggle('active', el.getAttribute('data-section-number') === this.getAttribute('data-section-number'));

          if (el === this) {
            this.labelClick(index);
          }
        });

        document.dispatchEvent(new CustomEvent('YG:anchor-change', {
          bubbles: true,
        }));
      }

      labelClick(index) {
        // 添加新的活动状态
        const parent = this.parentElement;
        if (parent && this.isScrollable(parent)) {
          const containerRect = parent.getBoundingClientRect();
          const targetRect = this.getBoundingClientRect();
          const scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 260;

          parent.scrollTo({
            left: scrollLeft,
            behavior: 'smooth',
          });
        }
      }

      isScrollable(el) {
        if (!el) return false;

        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        const overflowX = style.overflowX;

        const canScrollVertically =
          (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
        const canScrollHorizontally =
          (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;

        return canScrollVertically || canScrollHorizontally;
      }

      itemClick() {
        const sectionNumber = this.getAttribute('data-section-number');
        YGAnchorItem.isScroll = true;
        this.setActiveFromObserver();
        if (sectionNumber == 0) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        } else {
          const section = this.sections[sectionNumber - 1];
          if (!section) return;
          const offsetTop = section.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }

        setTimeout(() => {
          YGAnchorItem.isScroll = false;
        }, 600);
      }
    }
    if (!window.customElements.get('yg-anchor-item')) {
      window.customElements.define('yg-anchor-item', YGAnchorItem);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-collapse-button"] && !Shopify.designMode) return;
  try {
    class YGCollapseButton extends HTMLElement {
    #sectionEl;

    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    get $sectionEl() {
      this.#sectionEl = {
        targetEl: document.querySelector(`.${this.getAttribute('data-target-class')}`),
        buttonLabel: this.querySelector('.yg-link-label')
      };

      return this.#sectionEl;
    }

    get collapsedLines() {
      return Number(this.getAttribute('data-collapsed-lines') || 0);
    }

    get isClampMode() {
      return this.collapsedLines > 0;
    }

    connectedCallback() {
      if (!this.$sectionEl.targetEl) return;

      this.init();
      this.addEventListener('click', this.itemClick);
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
      window.removeEventListener('resize', this.handleResize);
    }

    init() {
      const target = this.$sectionEl.targetEl;

      if (this.isClampMode) {
        if (!target.classList.contains('yg-collapse-target-el')) {
          target.classList.add('yg-collapse-target-el');
        }

        if (target.hasAttribute('open')) {
          target.style.height = 'auto';
        } else {
          target.style.height = `${this.getCollapsedHeight()}px`;
        }

        this.syncClampVisibility();
        return;
      }

      if (!target.classList.contains('yg-collapse-target-el')) {
        target.classList.add('yg-collapse-target-el');
      }

      if (target.hasAttribute('open')) {
        target.style.height = 'auto';
      } else {
        target.style.height = '0px';
      }
    }

    handleResize() {
      if (!this.$sectionEl.targetEl) return;

      this.init();
    }

    syncClampVisibility() {
      const target = this.$sectionEl.targetEl;
      const buttonLabel = this.$sectionEl.buttonLabel;
      const collapsedHeight = this.getCollapsedHeight();

      if (!target) return;
      const isOverflowing = target.scrollHeight > collapsedHeight + 1;

      if (!isOverflowing) {
        this.hidden = true;
        this.removeAttribute('open');
        target.removeAttribute('open');
        target.style.height = 'auto';

        if (buttonLabel) {
          buttonLabel.innerText = this.getAttribute('data-more-label');
        }

        return;
      }

      this.hidden = false;

      if (buttonLabel) {
        buttonLabel.innerText = target.hasAttribute('open') ? this.getAttribute('data-less-label') : this.getAttribute('data-more-label');
      }
    }

    openSection() {
      const target = this.$sectionEl.targetEl;
      const buttonLabel = this.$sectionEl.buttonLabel;

      if (this.isClampMode) {
        target.setAttribute('open', '');
        this.setAttribute('open', '');
        target.style.height = `${target.offsetHeight}px`;
        target.offsetHeight;
        target.style.height = `${target.scrollHeight}px`;

        if (buttonLabel) {
          buttonLabel.innerText = this.getAttribute('data-less-label');
        }

        const onTransitionEnd = (event) => {
          if (event.propertyName !== 'height') return;

          target.style.height = 'auto';
          target.removeEventListener('transitionend', onTransitionEnd);
        };

        target.addEventListener('transitionend', onTransitionEnd);
        return;
      }

      target.style.height = `${target.offsetHeight}px`;
      target.offsetHeight;

      const endHeight = target.scrollHeight;
      target.style.height = `${endHeight}px`;
      target.setAttribute('open', '');
      this.setAttribute('open', '');

      if (buttonLabel) {
        buttonLabel.innerText = this.getAttribute('data-less-label');
      }

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;

        target.style.height = 'auto';
        target.removeEventListener('transitionend', onTransitionEnd);
      };

      target.addEventListener('transitionend', onTransitionEnd);
    }

    closeSection() {
      const target = this.$sectionEl.targetEl;
      const buttonLabel = this.$sectionEl.buttonLabel;

      if (!target.hasAttribute('open')) return;

      if (this.isClampMode) {
        const collapsedHeight = this.getCollapsedHeight();

        if (getComputedStyle(target).height === 'auto') {
          target.style.height = `${target.scrollHeight}px`;
        }

        target.offsetHeight;
        target.removeAttribute('open');
        this.removeAttribute('open');
        target.style.height = `${collapsedHeight}px`;

        if (buttonLabel) {
          buttonLabel.innerText = this.getAttribute('data-more-label');
        }

        this.syncClampVisibility();
        return;
      }

      this.removeAttribute('open');

      if (buttonLabel) {
        buttonLabel.innerText = this.getAttribute('data-more-label');
      }

      if (getComputedStyle(target).height === 'auto') {
        target.style.height = `${target.scrollHeight}px`;
      } else if (!target.style.height || target.style.height === '0px') {
        target.removeAttribute('open');
        target.style.height = '0px';
        return;
      }

      target.offsetHeight;

      target.style.height = '0px';
      target.removeAttribute('open');
      this.removeAttribute('open');

      if (buttonLabel) {
        buttonLabel.innerText = this.getAttribute('data-more-label');
      }
    }

    itemClick(event) {
      event.preventDefault();

      const target = this.$sectionEl.targetEl;
      if (!target) return;

      if (target.hasAttribute('open')) {
        this.closeSection();
      } else {
        this.openSection();
      }
    }

    getCollapsedHeight() {
      const target = this.$sectionEl.targetEl;
      if (!target) return 0;

      let lineHeight = parseFloat(getComputedStyle(target).lineHeight);

      if (Number.isNaN(lineHeight) && target.firstElementChild) {
        lineHeight = parseFloat(getComputedStyle(target.firstElementChild).lineHeight);
      }

      if (Number.isNaN(lineHeight)) {
        const fontSize = parseFloat(getComputedStyle(target).fontSize) || 16;
        lineHeight = fontSize * 1.6;
      }

      return lineHeight * this.collapsedLines;
    }
  }

  if (!window.customElements.get('yg-collapse-button')) {
    window.customElements.define('yg-collapse-button', YGCollapseButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-count-down"] && !Shopify.designMode) return;
  try {
    class YGCountDown extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.hasExpired = false;
    }

    connectedCallback() {
      this.removeAttribute('data-expired');
      this.targetDate = this.parseDate(this.dataset.date);

      if (!this.targetDate) {
        this.hidden = true;
        return;
      }

      this.updateCountdown();

      if (!this.hasExpired) {
        this.timer = window.setInterval(() => this.updateCountdown(), 1000);
      }
    }

    disconnectedCallback() {
      this.clearTimer();
    }

    parseDate(rawDate) {
      if (!rawDate) return null;

      const normalizedDate = rawDate.includes('T') ? rawDate : rawDate.replace(/-/g, '/');
      const parsedDate = new Date(normalizedDate);

      return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    }

    clearTimer() {
      if (!this.timer) return;

      window.clearInterval(this.timer);
      this.timer = null;
    }

    get itemMap() {
      if (this._itemMap) return this._itemMap;

      this._itemMap = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]')
      };

      return this._itemMap;
    }

    updateCountdown() {
      const diff = this.targetDate.getTime() - Date.now();

      if (diff <= 0) {
        this.handleExpiration();
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const displayMode = this.dataset.displayMode || 'dd_hh_mm_ss';
      const days = Math.floor(totalSeconds / 86400);
      const hours = displayMode === 'hh_mm_ss' ? Math.floor(totalSeconds / 3600) : Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (displayMode != 'hh_mm_ss') {
        this.renderValue(this.itemMap.days, days);
      }

      this.renderValue(this.itemMap.hours, hours);
      this.renderValue(this.itemMap.minutes, minutes);
      this.renderValue(this.itemMap.seconds, seconds);
    }

    renderValue(element, value) {
      if (!element) return;
      element.textContent = String(value).padStart(2, '0');
    }

    handleExpiration() {
      if (this.hasExpired) return;
      this.hasExpired = true;
      this.dataset.expired = 'true';
      this.clearTimer();

      if (this.dataset.endAction === 'hide_block' && this.dataset.blockId) {
        window.setTimeout(() => {
          if (!this.isConnected) return;

          this.dispatchEvent(
            new CustomEvent('yg:announcement-block-expired', {
              bubbles: true,
              composed: true,
              detail: {
                blockId: this.dataset.blockId
              }
            })
          );
        }, 0);
        return;
      }

      this.style.display = 'none';
    }
  }

  (() => {
    const boot = () => {
      if (!window.customElements.get('yg-count-down')) {
        window.customElements.define('yg-count-down', YGCountDown);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-dropdown"] && !Shopify.designMode) return;
  try {
    class YGDropdown extends YGUtils {
      #dropdownGroup;
      #transitionCleanup;
      #resizeObserver;
      static #groupRegistry = new Map();

      constructor() {
          super()
          this.itemClick = this.itemClick.bind(this);
          this.handleResize = this.handleResize.bind(this);
          this.debouncedResize = this.debounce(this.handleResize, 100);
      }

      #manageGroupRegistry(action) {
        const groupID = this.dataset.group
        if (!groupID) return action === 'get' ? null : undefined

        switch (action) {
          case 'add':
            if (!YGDropdown.#groupRegistry.has(groupID)) {
              YGDropdown.#groupRegistry.set(groupID, new Set())
            }
            YGDropdown.#groupRegistry.get(groupID).add(this)
            break
          case 'remove':
            if (YGDropdown.#groupRegistry.has(groupID)) {
              YGDropdown.#groupRegistry.get(groupID).delete(this)
            }
            break
          case 'get':
            const groupDropdowns = YGDropdown.#groupRegistry.get(groupID)
            this.#dropdownGroup = groupDropdowns ? Array.from(groupDropdowns) : null
            return this.#dropdownGroup
        }
      }

      get dropdownGroup() {
        if (this.#dropdownGroup) return this.#dropdownGroup
        return this.#manageGroupRegistry('get')
      }

      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl

        this._sectionsEl = {
          titleContainer: this.querySelector('.yg-dropdown-title-container'),
          contentContainer: this.querySelector('.yg-dropdown-content-container'),
          content: this.querySelector('.yg-dropdown-content')
        }

        return this._sectionsEl
      }

      connectedCallback() {
          this.#manageGroupRegistry('add')

          setTimeout(() => {
            this.initDropdownState()
          }, 60);
          if (this.sectionsEl.titleContainer) {
            this.sectionsEl.titleContainer.addEventListener('click', this.itemClick);
          }
          window.addEventListener('resize', this.debouncedResize);
          this.observeContentResize();
          this.setContentContainerHeight({ immediate: true });
      }

      disconnectedCallback() {
          this.#manageGroupRegistry('remove')

          if (this.sectionsEl.titleContainer) {
            this.sectionsEl.titleContainer.removeEventListener('click', this.itemClick);
          }
          window.removeEventListener('resize', this.debouncedResize);
          if (this.#resizeObserver) {
            this.#resizeObserver.disconnect();
            this.#resizeObserver = null;
          }
          this.clearTransitionCleanup();
      }

      observeContentResize() {
        const content = this.sectionsEl.content
        if (!content || typeof ResizeObserver === 'undefined') return

        if (this.#resizeObserver) {
          this.#resizeObserver.disconnect();
        }

        this.#resizeObserver = new ResizeObserver(() => {
          const contentContainer = this.sectionsEl.contentContainer
          if (!contentContainer || !this.hasAttribute('open')) return

          if (contentContainer.style.height && contentContainer.style.height !== 'auto') {
            contentContainer.style.height = `${content.scrollHeight}px`
          }
        });

        this.#resizeObserver.observe(content)
      }

      clearTransitionCleanup() {
        if (typeof this.#transitionCleanup === 'function') {
          this.#transitionCleanup();
        }
        this.#transitionCleanup = null;
      }

      registerTransitionCleanup(callback) {
        const contentContainer = this.sectionsEl.contentContainer
        if (!contentContainer) return

        this.clearTransitionCleanup()

        const handleTransitionEnd = (event) => {
          if (event.target !== contentContainer || event.propertyName !== 'height') return
          callback?.()
          this.clearTransitionCleanup()
        }

        contentContainer.addEventListener('transitionend', handleTransitionEnd)
        this.#transitionCleanup = () => {
          contentContainer.removeEventListener('transitionend', handleTransitionEnd)
        }
      }

      initDropdownState() {
        const group = this.dropdownGroup

        if (!group || !Array.isArray(group) || group.length === 0) {
          this.setContentContainerHeight({ immediate: true })
          return
        }

        if (group[0] !== this) return

        const openedDropdown = group.find((dropdown) => dropdown.hasAttribute('open'))
        const activeDropdown = openedDropdown || group[0]

        group.forEach((dropdown) => {
          if (dropdown === activeDropdown) {
            dropdown.openDropdown({ skipGroup: true, immediate: true, shouldDispatch: true })
          } else {
            dropdown.closeDropdown({ immediate: true, shouldDispatch: true })
          }
        })
      }

      itemClick() {
          this.setContentContainerHeight();
          let group = this.dropdownGroup;
          if (group && Array.isArray(group) && this.hasAttribute('open')) {
            if (!this.hasAttribute('data-accordion') && group.length > 1) {
              this.closeDropdown();
            }
            return;
          }

          this.hasAttribute('open')?this.closeDropdown():this.openDropdown();
      }

      handleResize() {
        this.setContentContainerHeight({ immediate: true });
      }

      setContentContainerHeight({ immediate = false } = {}) {
        const contentContainer = this.sectionsEl.contentContainer
        const content = this.sectionsEl.content
        if (!contentContainer || !content) return

        if (!this.hasAttribute('open')) {
          contentContainer.style.height = '0px'
          return
        }

        if (immediate) {
          contentContainer.style.height = 'auto'
          return
        }

        if (contentContainer.style.height !== 'auto') {
          contentContainer.style.height = `${content.scrollHeight}px`
        }
      }

      openDropdown({ skipGroup = false, immediate = false, shouldDispatch = true } = {}){
        const contentContainer = this.sectionsEl.contentContainer
        const content = this.sectionsEl.content
        if (!contentContainer || !content) return

        let group = this.dropdownGroup;
        if (!skipGroup && group && Array.isArray(group)) {
            group.forEach(dropdown => {
                if (dropdown !== this) {
                    dropdown.closeDropdown({ shouldDispatch: false });
                }
            });
        }

        this.setAttribute('open', '');

        if (immediate) {
          contentContainer.style.height = 'auto'
        } else {
          this.clearTransitionCleanup()
          const startHeight = contentContainer.style.height === 'auto' ? content.scrollHeight : contentContainer.offsetHeight
          contentContainer.style.height = `${startHeight}px`
          contentContainer.offsetHeight
          contentContainer.style.height = `${content.scrollHeight}px`

          this.registerTransitionCleanup(() => {
            if (this.hasAttribute('open')) {
              contentContainer.style.height = 'auto'
            }
          })
        }

        if (shouldDispatch) {
          document.dispatchEvent(new CustomEvent('YG:dropdown-open', {
            bubbles: true,
            composed: true,
            detail: {
              id: this.getAttribute('data-id')
            }
          }));
        }
      }

      closeDropdown({ immediate = false, shouldDispatch = true } = {}){
        const contentContainer = this.sectionsEl.contentContainer
        const content = this.sectionsEl.content
        if (!contentContainer || !content) return
        if (!this.hasAttribute('open') && !immediate) return

        this.clearTransitionCleanup()

        if (immediate) {
          this.removeAttribute('open');
          contentContainer.style.height = '0px'
          return
        }

        const currentHeight = contentContainer.style.height === 'auto' ? content.scrollHeight : contentContainer.offsetHeight
        contentContainer.style.height = `${currentHeight}px`

        contentContainer.offsetHeight
        this.removeAttribute('open');
        contentContainer.style.height = '0px'

        if (shouldDispatch) {
          document.dispatchEvent(new CustomEvent('YG:dropdown-close', {
            bubbles: true,
            composed: true,
            detail: {
              id: this.getAttribute('data-id')
            }
          }));
        }
      }
  }
  if (!window.customElements.get('yg-dropdown')) {
      window.customElements.define('yg-dropdown',YGDropdown)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLazyLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getLazyLoader) {
          this.getLazyLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('yg-mega-menu-tabs')) {
    class YGMegaMenuTabs extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          return;
        }

        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.viewAllLink = this.querySelector('.yg-mega-menu__view-all-link');
        this.handleTabHover = this.handleTabHover.bind(this);
        this.handleFocusin = this.handleFocusin.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);

        this.tabs.forEach((tab) => {
          tab.addEventListener('mouseenter', this.handleTabHover);
        });
        this.addEventListener('focusin', this.handleFocusin);
        this.addEventListener('keydown', this.handleKeydown);

        const initialIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        this.activateTab(initialIndex >= 0 ? initialIndex : 0, false);
      }

      disconnectedCallback() {
        this.tabs.forEach((tab) => {
          tab.removeEventListener('mouseenter', this.handleTabHover);
        });
        this.removeEventListener('focusin', this.handleFocusin);
        this.removeEventListener('keydown', this.handleKeydown);
        this.initialized = false;
      }

      handleTabHover(event) {
        this.activateTab(Number(event.currentTarget.dataset.tabIndex), false);
      }

      handleFocusin(event) {
        const tab = event.target.closest('[role="tab"]');

        if (!tab || !this.contains(tab)) {
          return;
        }

        this.activateTab(Number(tab.dataset.tabIndex), false);
      }

      handleKeydown(event) {
        const tab = event.target.closest('[role="tab"]');

        if (!tab || !this.contains(tab)) {
          return;
        }

        const currentIndex = this.tabs.indexOf(tab);

        if (currentIndex === -1) {
          return;
        }

        let nextIndex = currentIndex;

        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          nextIndex = (currentIndex + 1) % this.tabs.length;
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = this.tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        this.activateTab(nextIndex);
      }

      activateTab(index, shouldFocus = true) {
        if (!Number.isFinite(index) || !this.tabs[index] || !this.panels[index]) {
          return;
        }

        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;

          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');

          if (isActive && shouldFocus) {
            tab.focus();
          }

          if (isActive) {
            this.updateViewAllLink(tab);
          }
        });

        this.panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== index;
        });
      }

      updateViewAllLink(tab) {
        if (!this.viewAllLink) {
          return;
        }

        const viewAllUrl = tab.dataset.viewAllUrl;

        if (!viewAllUrl) {
          this.viewAllLink.removeAttribute('href');
          this.viewAllLink.setAttribute('aria-disabled', 'true');
          return;
        }

        this.viewAllLink.href = viewAllUrl;
        this.viewAllLink.removeAttribute('aria-disabled');
      }
    }

    window.customElements.define('yg-mega-menu-tabs', YGMegaMenuTabs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-open-popup"] && !Shopify.designMode) return;
  try {
    class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.handleActivate = this.handleActivate.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    getDirectPopupTemplate() {
      return Array.from(this.children).find((child) => child.matches('template, .yg-popup-template')) || null;
    }

    connectedCallback() {
      this.sectionsEl = {
        popupTemplate: this.getDirectPopupTemplate(),
      };

      if (!this.hasAttribute('role')) {
        this.setAttribute('role', 'button');
      }

      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '0');
      }

      this.addEventListener('click', this.handleActivate);
      this.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleActivate);
      this.removeEventListener('keydown', this.handleKeydown);
    }

    getPopupTemplate() {
      if (this.sectionsEl.popupTemplate) {
        return this.sectionsEl.popupTemplate;
      }

      if (!this.dataset.popupId) {
        return null;
      }

      return document.getElementById(`yg-popup-template-${this.dataset.popupId}`);
    }

    handleKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      this.handleActivate();
    }

    handleActivate() {
      const popupTemplate = this.getPopupTemplate();

      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }

      this.dispatchEvent(
        new CustomEvent('YG:openPopup', {
          bubbles: true,
          detail: {
            popupTemplate,
            popupClass: this.dataset.popupClass,
            closeBtnClass: this.dataset.closeBtnClass,
          },
        })
      );
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-popup"] && !Shopify.designMode) return;
  try {
    class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.closePopup = this.closePopup.bind(this);
      this.openPopup = this.openPopup.bind(this);
    }

    // 优化：缓存并懒加载元素，只查询一次，提高性能和可维护性
    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        'close': this.querySelector('.yg-popup-box-close'),
        'content-inner': this.querySelector('.yg-popup-box-content-inner'),
        'body': document.body,
      };
      
      return this._sectionsEl;
    }

    connectedCallback() {
      this.addEventListener('click', this.closePopup);
      document.addEventListener('YG:openPopup', this.openPopup);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closePopup);
      document.removeEventListener('YG:openPopup', this.openPopup);
    }

    openPopup(e) {
      const { popupTemplate, popupClass, closeBtnClass } = e.detail || {};
      
      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }
      // popupTemplate：需要替换的元素
      this.sectionsEl['close'].classList.add(`${closeBtnClass}`)
      this.classList.add(`${popupClass}`)
      this.sectionsEl['content-inner'].innerHTML = popupTemplate.innerHTML;
      this.sectionsEl['body'].style.overflow = 'hidden';
      this.style.display = 'flex';
    }

    closePopup(e) {
      const closeBtn = e.target.closest('.yg-popup-box-close');
      const popupBox = e.target.closest('.yg-popup-box');
      if (closeBtn || (popupBox && e.target === popupBox)) {
        this.style.display = 'none';
        this.sectionsEl['content-inner'].innerHTML = '';
        this.sectionsEl['body'].style.overflow = 'auto';
        this.sectionsEl['close'].className = 'yg-popup-box-close';
        this.className = 'yg-popup-box';
      }
    } 
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-coupon-banner-01"] && !Shopify.designMode) return;
  try {
    class YGProductCouponBanner01 extends HTMLElement {
    constructor() {
      super();
      this.handleBlockExpired = this.handleBlockExpired.bind(this);
    }

    connectedCallback() {
      this.addEventListener('yg:announcement-block-expired', this.handleBlockExpired);
      this.syncExpiredState();
    }

    disconnectedCallback() {
      this.removeEventListener('yg:announcement-block-expired', this.handleBlockExpired);
    }

    syncExpiredState() {
      const expiredCountdown = this.querySelector('yg-count-down[data-expired="true"]');

      if (!expiredCountdown) {
        return;
      }

      if (expiredCountdown.dataset.blockId !== this.dataset.blockId) {
        return;
      }

      this.hidden = true;
    }

    handleBlockExpired(event) {
      if (!event.detail || event.detail.blockId !== this.dataset.blockId) {
        return;
      }

      this.hidden = true;
    }
  }

  if (!window.customElements.get('yg-product-coupon-banner-01')) {
    window.customElements.define('yg-product-coupon-banner-01', YGProductCouponBanner01);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-coupon-code-01"] && !Shopify.designMode) return;
  try {
    class YGProductCouponCode01 extends HTMLElement {
    constructor() {
      super();
      this.copyTimeout = null;
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.copyTrigger = this.querySelector('[data-copy-trigger]');
      this.statusElement = this.querySelector('[data-copy-status]');

      if (this.copyTrigger) {
        this.copyTrigger.addEventListener('click', this.handleClick);
      }

      this.labelElement = this.querySelector('.yg-product-coupon-code-01__label');
      this.defaultLabel = this.labelElement ? this.labelElement.textContent : '';
    }

    disconnectedCallback() {
      if (this.copyTrigger) {
        this.copyTrigger.removeEventListener('click', this.handleClick);
      }

      if (this.copyTimeout) {
        window.clearTimeout(this.copyTimeout);
      }
    }

    async handleClick() {
      if (!this.dataset.discountCode) {
        this.showFeedback(this.dataset.copyErrorText || 'Copy failed');
        return;
      }

      const copied = await this.copyText(this.dataset.discountCode);

      if (copied) {
        this.showFeedback(this.dataset.copySuccessText || 'Copied', true);
        return;
      }

      this.showFeedback(this.dataset.copyErrorText || 'Copy failed');
    }

    async copyText(value) {
      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(value);
          return true;
        } catch (error) {
        }
      }

      const textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';

      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      const copied = document.execCommand('copy');
      document.body.removeChild(textarea);

      return copied;
    }

    showFeedback(message, copied = false) {
      if (this.copyTimeout) {
        window.clearTimeout(this.copyTimeout);
      }

      if (this.labelElement) {
        this.labelElement.textContent = message;
      }

      if (this.statusElement) {
        this.statusElement.textContent = message;
      }

      if (copied) {
        this.dataset.copied = 'true';
      } else {
        this.removeAttribute('data-copied');
      }

      this.copyTimeout = window.setTimeout(() => {
        if (this.labelElement) {
          this.labelElement.textContent = this.defaultLabel;
        }

        if (this.statusElement) {
          this.statusElement.textContent = '';
        }

        this.removeAttribute('data-copied');
      }, 3000);
    }
  }

  if (!window.customElements.get('yg-product-coupon-code-01')) {
    window.customElements.define('yg-product-coupon-code-01', YGProductCouponCode01);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-parts"] && !Shopify.designMode) return;
  try {
    window.__ygProductPartsFormatMoney = window.__ygProductPartsFormatMoney || function(cents, format) {
      const moneyFormat = format || window.themeVariables?.settings?.moneyFormat || '__amount__';
      const amount = Number(cents) || 0;

      const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
        const value = (number / 100).toFixed(precision);
        const parts = value.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts[1] ? parts.join(decimal) : parts[0];
      };

      const placeholderMatch = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}|__(\w+)__/);
      const placeholder = placeholderMatch ? placeholderMatch[1] || placeholderMatch[2] : 'amount';
      let value = '';

      switch (placeholder) {
        case 'amount':
          value = formatWithDelimiters(amount, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(amount, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(amount, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(amount, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(amount, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(amount, 0, ' ', '.');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(amount, 2, "'", '.');
          break;
        default:
          value = formatWithDelimiters(amount, 2);
      }

      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}|__\w+__/, value).trim();
    };

    if (!window.customElements.get('yg-product-parts')) {
      class YGProductParts extends HTMLElement {
        connectedCallback() {
          if (this._initialized) {
            return;
          }

          this._initialized = true;
          this._onClick = this._onClick.bind(this);
          this.addEventListener('click', this._onClick);
          this._emitSelectionChange();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this._onClick);
        }

        getSelectedPartsPrice() {
          return this._getSelectedItems().reduce((total, item) => {
            return total + this._toNumber(item.dataset.price);
          }, 0);
        }

        getSelectedItems() {
          return this._getSelectedItems().map((item) => this._serializeItem(item));
        }

        _getSelectedItems() {
          return Array.from(this.querySelectorAll('.yg-parts-item.is-selected')).filter((item) => item.dataset.available !== 'false');
        }

        _onClick(event) {
          const option = event.target.closest('.option-value');

          if (option && this.contains(option)) {
            this._handleOptionClick(option);
            return;
          }

          const item = event.target.closest('.yg-parts-item');

          if (!item || !this.contains(item) || item.dataset.available === 'false') {
            return;
          }

          const nextSelected = item.dataset.selected !== 'true';
          item.dataset.selected = nextSelected ? 'true' : 'false';
          item.classList.toggle('is-selected', nextSelected);
          this._emitSelectionChange();
        }

        _handleOptionClick(option) {
          const item = option.closest('.yg-parts-item');

          if (!item) {
            return;
          }

          item.querySelectorAll('.option-value').forEach((optionValue) => {
            optionValue.classList.remove('active');
          });
          option.classList.add('active');

          if (option.dataset.variantId) {
            item.dataset.variantId = option.dataset.variantId;
          }

          if (option.dataset.price) {
            item.dataset.price = option.dataset.price;
          }

          if (option.dataset.comparePrice) {
            item.dataset.comparePrice = option.dataset.comparePrice;
          }

          this._updateItemPrice(item);

          if (item.dataset.selected === 'true') {
            this._emitSelectionChange();
          }
        }

        _updateItemPrice(item) {
          const moneyFormat = this.querySelector('yg-product-parts-total')?.dataset.moneyFormat;
          const priceElement = item.querySelector('[data-part-price]');
          const compareElement = item.querySelector('[data-part-compare-price]');
          const price = this._toNumber(item.dataset.price);
          const comparePrice = this._toNumber(item.dataset.comparePrice);

          if (priceElement) {
            priceElement.textContent = window.__ygProductPartsFormatMoney(price, moneyFormat);
          }

          if (!compareElement) {
            return;
          }

          if (comparePrice > price) {
            compareElement.hidden = false;
            compareElement.textContent = window.__ygProductPartsFormatMoney(comparePrice, moneyFormat);
          } else {
            compareElement.hidden = true;
            compareElement.textContent = '';
          }
        }

        _emitSelectionChange() {
          this.dispatchEvent(new CustomEvent('yg:product-parts:change', {
            bubbles: true,
            detail: {
              selectedPartsPrice: this.getSelectedPartsPrice(),
              selectedItems: this.getSelectedItems()
            }
          }));
        }

        _serializeItem(item) {
          return {
            productId: item.dataset.productId || '',
            variantId: item.dataset.variantId || '',
            price: this._toNumber(item.dataset.price),
            comparePrice: this._toNumber(item.dataset.comparePrice),
            available: item.dataset.available !== 'false',
            title: item.dataset.title || '',
            quantity: 1
          };
        }

        _toNumber(value) {
          return Number.parseInt(value || '0', 10) || 0;
        }
      }

      window.customElements.define('yg-product-parts', YGProductParts);
    }

    if (!window.customElements.get('yg-product-parts-total')) {
      class YGProductPartsTotal extends HTMLElement {
        connectedCallback() {
          if (this._initialized) {
            return;
          }

          this._initialized = true;
          this._productInfo = this.closest('.product-info') || document;
          this._partsRoot = this.closest('yg-product-parts');
          this._priceElement = this.querySelector('[data-total-price]');
          this._handlePartsChange = this._handlePartsChange.bind(this);
          this._handleVariantChange = this._handleVariantChange.bind(this);

          this._productInfo.addEventListener('yg:product-parts:change', this._handlePartsChange);
          this._productInfo.addEventListener('variant:change', this._handleVariantChange);
          this.render();
        }

        disconnectedCallback() {
          this._productInfo?.removeEventListener('yg:product-parts:change', this._handlePartsChange);
          this._productInfo?.removeEventListener('variant:change', this._handleVariantChange);
        }

        _handlePartsChange() {
          this.render();
        }

        _handleVariantChange(event) {
          const nextPrice = event.detail?.variant?.price;

          if (Number.isFinite(nextPrice)) {
            this.dataset.basePrice = String(nextPrice);
          }

          this.render();
        }

        render() {
          if (!this._priceElement) {
            return;
          }

          const totalPrice = this._getBasePrice() + this._getPartsPrice();
          this._priceElement.textContent = window.__ygProductPartsFormatMoney(totalPrice, this.dataset.moneyFormat);
        }

        _getBasePrice() {
          return Number.parseInt(this.dataset.basePrice || '0', 10) || 0;
        }

        _getPartsPrice() {
          return this._partsRoot?.getSelectedPartsPrice?.() || 0;
        }
      }

      window.customElements.define('yg-product-parts-total', YGProductPartsTotal);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-progress-bar"] && !Shopify.designMode) return;
  try {
    class YGProgressBar extends HTMLElement {
    #videoListenersAttached = false;

    constructor() {
      super();
      this.video = null;
      this.animationFrame = null;
    }

    connectedCallback() {
    }

    get isCircle() {
      return this.classList.contains('yg-progress-circle');
    }

    get circleProgressElement() {
      return this.querySelector('.circle-progress');
    }

    findVideo() {
      let isMobile = window.innerWidth < 699;
      let id = this.getAttribute('data-id');
      if (isMobile && this.getAttribute('data-mobile-id')) {
        id = this.getAttribute('data-mobile-id');
      }
      if (!id) return null;

      return document.querySelector(`yg-video[data-id="${id}"]`);
    }

    getVideoElement(videoComponent) {
      if (!videoComponent) return null;
      return videoComponent.querySelector('.yg-video-iframe');
    }

    syncWithVideo() {
      if (!this.video) return;

      const videoEl = this.getVideoElement(this.video);
      if (!videoEl) return;

      const duration = this.video.duration || videoEl.duration || 0;
      const currentTime = videoEl.currentTime || 0;

      if (duration > 0) {
        const progress = (currentTime / duration) * 100;
        
        if (this.isCircle) {
          this.syncCircleProgress(progress);
        } else {
          this.style.setProperty('--progress-width', `${progress}%`);
        }
      }
    }

    syncCircleProgress(progress) {
      const circleEl = this.circleProgressElement;
      if (!circleEl) return;

      const circumference = parseFloat(getComputedStyle(this).getPropertyValue('--circle-circumference')) || 100;
      const dashArray = (progress / 100) * circumference;
      circleEl.style.strokeDasharray = `${dashArray} ${circumference}`;
    }

    startProgress() {
      const id = this.getAttribute('data-id');
      this.video = this.findVideo();

      if (this.video) {
        this.startVideoProgress();
      } else {
        this.startAnimationProgress();
      }
    }

    startAnimationProgress() {
      const id = this.getAttribute('data-id');
      this.classList.add('start-progress');

      if (this.isCircle) {
        const circleEl = this.circleProgressElement;
        if (circleEl) {
          const style = getComputedStyle(this);
          const duration = parseFloat(style.getPropertyValue('--duration')) || 10;
          const circumference = parseFloat(style.getPropertyValue('--circle-circumference')) || 100;
          
          let startTime = null;
          
          const animate = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const elapsed = (timestamp - startTime) / 1000;
            const progress = Math.min(elapsed / duration, 1);
            
            const dashArray = progress * circumference;
            circleEl.style.strokeDasharray = `${dashArray} ${circumference}`;
            
            if (progress < 1) {
              this.animationFrame = requestAnimationFrame(animate);
            } else {
              this.stopProgress(true);
            }
          };
          
          this.animationFrame = requestAnimationFrame(animate);
        }
        return;
      }

      let handleAnimationEnd = () => {
        this.stopProgress(true);
        this.removeEventListener('animationend', handleAnimationEnd);
      };

      this.addEventListener('animationend', handleAnimationEnd);
    }

    startVideoProgress() {
      this.classList.add('video-sync');

      const videoEl = this.getVideoElement(this.video);
      if (!videoEl) {
        this.#waitForVideo();
        return;
      }

      this.#initVideoListeners(videoEl);

      if (!videoEl.paused) {
        this.classList.add('playing');
        this.#startVideoUpdate(videoEl);
      }
    }

    #waitForVideo() {
      const observer = new MutationObserver(() => {
        const videoEl = this.getVideoElement(this.video);
        if (videoEl) {
          observer.disconnect();
          this.#initVideoListeners(videoEl);
          if (!videoEl.paused) {
            this.classList.add('playing');
            this.#startVideoUpdate(videoEl);
          }
        }
      });
      observer.observe(this.video, { childList: true, subtree: true });
    }

    #initVideoListeners(videoEl) {
      if (this.#videoListenersAttached) return;
      this.#videoListenersAttached = true;

      videoEl.addEventListener('play', () => {
        this.classList.add('playing');
        this.#startVideoUpdate(videoEl);
      });

      videoEl.addEventListener('pause', () => {
        this.classList.remove('playing');
        this.#stopVideoUpdate();
      });

      videoEl.addEventListener('ended', () => {
        this.stopProgress(true);
      });

      videoEl.addEventListener('timeupdate', () => {
        this.syncWithVideo();
      });
    }

    #startVideoUpdate(videoEl) {
      this.#stopVideoUpdate();
      const updateProgress = () => {
        this.syncWithVideo();
        if (!videoEl.paused && !videoEl.ended) {
          this.animationFrame = requestAnimationFrame(updateProgress);
        }
      };
      updateProgress();
    }

    #stopVideoUpdate() {
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }
    }

    stopProgress(completed = false) {
      this.classList.remove('start-progress', 'playing', 'video-sync');

      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }

      if (this.isCircle && !completed) {
        const circleEl = this.circleProgressElement;
        if (circleEl) {
          const circumference = parseFloat(getComputedStyle(this).getPropertyValue('--circle-circumference')) || 100;
          circleEl.style.strokeDasharray = `0 ${circumference}`;
        }
      }

      if (completed) {
        const id = this.getAttribute('data-id');
        document.dispatchEvent(new CustomEvent('YG:progress-end', {
          bubbles: true,
          composed: true,
          detail: { id }
        }));
      }
    }
  }

  if (!window.customElements.get('yg-progress-bar')) {
    window.customElements.define('yg-progress-bar', YGProgressBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLazyLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.loop = this.getAttribute('data-loop');
      this.type = this.getAttribute('data-type');
      this.enablePause = this.getAttribute('data-enable-pause') === 'true';
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return this.querySelector('template');
    }

    get videoButton() {
      return this.querySelector('.yg-video-button');
    }

    get playVideoButton() {
      return this.querySelector('.yg-video-button .yg-play');
    }

    get pauseVideoButton() {
      return this.querySelector('.yg-video-button .yg-pause');
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      this.pauseVideoButton?.addEventListener('click', ()=>this.pauseVideo());
      if (this.autoplay == 'true' && this.popup == 'false') {
        this.getLazyLoader().observe(this);
      }

      // Idle warmup for HTML5 <video> only (skip iframes) to improve first play without blocking main thread.
      this.scheduleHtml5VideoWarmup();
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.template,
            },
          })
        );

        return;
      }

      this.image?.classList.add('close');
      this.switcherVideoButtonState("play")
      if (!this.videoContainer) {
        this.appendChild(this.template?.content.cloneNode(true));
      }

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');

        this.videoContainer.classList.remove('close');
        videos.forEach(video => {
          video.play();
          // 监听video进度，当进度到达100%，且不循环时切换按钮
          video.addEventListener('timeupdate', () => {
            if (
              video.duration &&
              video.currentTime >= video.duration &&
              this.loop == 'false'
            ) {
              this.pauseVideo();
              this.switcherVideoButtonState("pause");
            }
          });
        });
      }

      
    }

    pauseVideo() {
      this.image?.classList.remove('close');
      this.switcherVideoButtonState("pause")
      
      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        if (!this.enablePause) {
          this.videoContainer.classList.add('close');
        }

        videos.forEach(video => {
          video.pause();
          if (!this.enablePause) {
            video.currentTime = 0;
          }
        });
      } else {
        this.videoContainer?.remove();
      }
    }

    switcherVideoButtonState (state = "play") {
      if (state == "pause") {
        if (!this.enablePause) {
          this.videoButton?.classList.remove('hide');
        } else {
          this.playVideoButton?.classList.remove('hide');
          this.pauseVideoButton?.classList.add('hide');
        }
        return;
      }
      if (state == "play") {
        if (!this.enablePause) {
          this.videoButton?.classList.add('hide');
        } else {
          this.playVideoButton?.classList.add('hide');
          this.pauseVideoButton?.classList.remove('hide');
        }
        return;
      }
    }

    scheduleHtml5VideoWarmup() {
      // Run once per element instance
      if (this.__ygHtml5WarmupScheduled) return;
      this.__ygHtml5WarmupScheduled = true;

      // Respect "Save-Data" users
      if (navigator?.connection?.saveData) return;

      const run = () => {
        try {
          const urls = this.getPreferredHtml5VideoUrls();
          urls.forEach((url) => this.warmupHtml5VideoUrl(url));
        } catch (e) {
          // Never break section rendering due to warmup.
        }
      };

      // Schedule work in idle time to avoid competing with main thread.
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 3000 });
      } else {
        window.setTimeout(run, 1200);
      }
    }

    getPreferredHtml5VideoUrls() {
      const isMobile = window.matchMedia && window.matchMedia('(max-width: 699px)').matches;

      // Prefer template content (when video is deferred) else DOM.
      const root = this.template?.content || this.videoContainer || this;

      // Only HTML5 <video> sources; explicitly skip iframe videos.
      const urls = [];

      // Prefer <source src> which is what Shopify video_tag usually outputs.
      const sources = root.querySelectorAll?.('video.yg-video-iframe source[src]') || [];
      sources.forEach((sourceEl) => {
        const videoEl = sourceEl.closest('video.yg-video-iframe');
        if (!videoEl) return;
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(sourceEl.getAttribute('src'));
      });

      // Fallback: <video src="...">
      const videos = root.querySelectorAll?.('video.yg-video-iframe[src]') || [];
      videos.forEach((videoEl) => {
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(videoEl.getAttribute('src'));
      });

      return [...new Set(urls.filter(Boolean))].filter((u) => !u.startsWith('blob:'));
    }

    warmupHtml5VideoUrl(url) {
      if (!url) return;

      // De-dupe across the whole page
      window.__ygWarmupVideoUrls ||= new Set();
      if (window.__ygWarmupVideoUrls.has(url)) return;
      window.__ygWarmupVideoUrls.add(url);

      // Hint preload (low priority where supported)
      try {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'video';
        link.href = url;
        link.crossOrigin = 'anonymous';
        // Some Chromium builds support this; safe elsewhere.
        link.fetchPriority = 'low';
        document.head.appendChild(link);
      } catch (e) {}

      // Prime HTTP cache with a small Range request (best-effort). Only for same-origin / Shopify CDN to avoid CORS surprises.
      try {
        const u = new URL(url, window.location.href);
        const isSameOrigin = u.origin === window.location.origin;
        const isShopifyCdn = u.hostname.endsWith('cdn.shopify.com');
        if (!isSameOrigin && !isShopifyCdn) return;

        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), 4000);

        fetch(u.toString(), {
          method: 'GET',
          mode: 'cors',
          credentials: 'omit',
          cache: 'force-cache',
          headers: {
            Range: 'bytes=0-1048575',
          },
          signal: controller.signal,
        })
          .catch(() => {})
          .finally(() => window.clearTimeout(timeoutId));
      } catch (e) {}
    }

  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
